import AddressInput from 'js/components/common/AddressInput';
import ContinueButton from "js/components/core/SteppedPage/ContinueButton";
import { inject, observer, Observer } from 'mobx-react';
import React from 'react';

@inject('page')
@observer
export default class PickupDetails extends React.Component {
  page = this.props.page;

  render() {
    return (
      <div className='tw-space-y-4'>
        <div>
          <h6 className='tw-font-semibold'>Item Pick-up details</h6>
          <p className='tw-mb-4'>Pick up address</p>
        </div>

        <AddressInput
          address={this.page.address}
          onChange={this.page.addressSaved}
        />

        <ContinueButton disabled={false}>Continue</ContinueButton>
      </div>
    );
  }
}
